export default "__VITE_ASSET__BYUTG91x__"